import { isFocusable } from 'tabbable';

function isLooselyFocusable(element) {
  var target = element;

  while (target !== null) {
    if (isFocusable(target) || target.hasAttribute('data-loosely-focusable')) {
      return true;
    }

    target = target.parentElement;
  }

  return false;
}

export { isLooselyFocusable };